import React, { useEffect, useState, useRef } from 'react';
import { Line } from 'react-chartjs-2';
import io from 'socket.io-client';
import {
  Chart,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const socket = io(process.env.REACT_APP_SOCKET_URL || 'https://pochelo.online');

const UMBRAL_AMPERAJE = 25;
const COLOR_ALERTA_PUNTO = 'red';
const RADIO_PUNTO_NORMAL = 2;
const RADIO_PUNTO_ALERTA = 4;
const SONIDO_ALERTA_PATH = '/alerta.mp3';

const LineChart = () => {
    const [chartData, setChartData] = useState({
        labels: Array.from({ length: 15 }, (_, i) => i + 1),
        datasets: [],
    });
    const [alertaActiva, setAlertaActiva] = useState({});
    const audioPlayer = useRef(null);

    useEffect(() => {
        audioPlayer.current = new Audio(SONIDO_ALERTA_PATH);
        audioPlayer.current.load();

        const dataMap = JSON.parse(localStorage.getItem('dataMap')) || {};
        const colorMap = JSON.parse(localStorage.getItem('colorMap')) || {};
        const colors = ['rgb(232, 226, 156)', 'rgb(183, 239, 205)', ' #d9c176', ' #a699f3'];
        // Colores solicitados por máquina (1..4) - Gama azul pastel
        const colorPorMaquina = {
            1: '#114e64ff',    // azul pastel claro
            2: '#1874a5ff',    // azul pastel medio
            3: '#2e4c5aff',    // azul pastel
            4: '#17acf1ff',    // azul pastel oscuro
        };
        const updateChartData = () => {
            const datasets = Object.keys(dataMap)
                .filter(key => {
                    // Solo máquinas 1 a 4
                    const match = key.match(/\d+/);
                    const num = match ? parseInt(match[0], 10) : 1;
                    
                    return num >= 1 && num <= 4;
                })
                .map((key) => {
        const datosMaquina = dataMap[key] || [];
        const match = key.match(/\d+/);
        const num = match ? parseInt(match[0], 10) : 1;
        const colorLinea = colorPorMaquina[num] || '#B8F1FF';
        const pointBackgroundColors = datosMaquina.map(valor =>
            valor > UMBRAL_AMPERAJE ? COLOR_ALERTA_PUNTO : colorLinea
        );
        const pointRadii = datosMaquina.map(valor =>
            (valor > UMBRAL_AMPERAJE ? RADIO_PUNTO_ALERTA : RADIO_PUNTO_NORMAL)
        );

                    return {
                        label: ` ${key}`,
                        data: datosMaquina,
                        fill: false,
                        borderColor: colorLinea,
                        tension: 0.6,
                        pointRadius: pointRadii,
                        pointHoverRadius: RADIO_PUNTO_ALERTA + 2,
                        borderWidth: window.innerWidth < 600 ? 0.8 : 1.5,
                        pointBackgroundColor: pointBackgroundColors,
                    };
                });

            setChartData({
                labels: Array.from({ length: 15 }, (_, i) => i + 1),
                datasets,
            });
        };

        updateChartData();

        socket.on('mqttData', (data) => {
            const { maquinaId, amperaje } = data;

            if (typeof amperaje !== 'number') {
                console.warn(`Amperaje no es un número para ${maquinaId}:`, amperaje);
                return;
            }

            const match = maquinaId.match(/\d+/);
            if (!match || !match[0]) {
                console.warn(`No se pudo extraer maquinaIdNum de ${maquinaId}`);
                return;
            }
            const maquinaIdNum = parseInt(match[0], 10);

            if (maquinaIdNum >= 1 && maquinaIdNum <= 4) {
                if (!dataMap[maquinaId]) {
                    dataMap[maquinaId] = Array(15).fill(0);
                    colorMap[maquinaId] = colors[Object.keys(colorMap).length % colors.length];
                }

                dataMap[maquinaId].push(amperaje);
                if (dataMap[maquinaId].length > 15) {
                    dataMap[maquinaId].shift();
                }

                if (amperaje > UMBRAL_AMPERAJE) {
                    if (!alertaActiva[maquinaId]) {
                        alert(`¡Alerta! ${maquinaId} ha superado el umbral de amperaje: ${amperaje}A`);
                        if (audioPlayer.current) {
                            audioPlayer.current.play().catch(error => console.error("Error al reproducir sonido:", error));
                        }
                        setAlertaActiva(prev => ({ ...prev, [maquinaId]: true }));
                    }
                } else {
                    if (alertaActiva[maquinaId]) {
                        setAlertaActiva(prev => ({ ...prev, [maquinaId]: false }));
                    }
                }

                localStorage.setItem('dataMap', JSON.stringify(dataMap));
                localStorage.setItem('colorMap', JSON.stringify(colorMap));
                updateChartData();
            }
        });

        return () => {
            socket.off('mqttData');
            if (audioPlayer.current) {
                audioPlayer.current.pause();
                audioPlayer.current.src = '';
            }
        };
    }, [alertaActiva]);

    const options = {
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: { color: 'rgba(123, 104, 238, 0.3)' },
                ticks: { color: '#FFFFFF', padding: 10, font: { family: 'Roboto', size: 12, weight: '300' } }
            },
            y: {
                min: 0, max: 25,
                grid: { color: 'rgba(123, 104, 238, 0.3)' },
                ticks: { color: '#FFFFFF', padding: 10, font: { family: 'Roboto', size: 12, weight: '300' } }
            }
        },
        plugins: {
            legend: {
                labels: {
                    color: '#FFFFFF',
                    font: { family: 'Roboto', size: 12, weight: '300'}
                }
            }
        }
    };

    return <Line data={chartData} options={options} />;
};

export default LineChart;